"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVariantKeyByAttributes = void 0;
const attributesIgnoredForVariants_1 = require("../attributesIgnoredForVariants");
const generateVariantKeyByAttributes = (attributes = []) => {
    let variantInfo = attributes
        .sort((a, b) => (a.attribute < b.attribute ? -1 : 1))
        .reduce((accum, currentAttribute) => {
        if (!currentAttribute.value)
            return accum;
        if (attributesIgnoredForVariants_1.attributesIgnoredForVariants.includes(currentAttribute.attribute))
            return accum;
        accum.key += currentAttribute.value + '/';
        accum.schema += currentAttribute.attribute + '/';
        return accum;
    }, { key: '', schema: '' });
    if (variantInfo.key.length) {
        variantInfo.key = variantInfo.key.slice(0, -1);
    }
    if (variantInfo.schema.length) {
        variantInfo.schema = variantInfo.schema.slice(0, -1);
    }
    return variantInfo;
};
exports.generateVariantKeyByAttributes = generateVariantKeyByAttributes;
//# sourceMappingURL=generateVariantKeyByAttributes.js.map